import { io } from "socket.io-client";
import { setGameSettings } from "../redux/slices/gameSettingsSlice";
import store from "../redux/store";

const SOCKET_SERVER_URL = process.env.REACT_APP_SLOT_URL;

let socket;

export const fetchConfig = async () => {
    try {
        socket.emit("getConfig");

        socket.on("get_config", (response) => {
            console.log("Response received from socket:", response);

            if (response?.statusCode === 200 && response.success) {
                store.dispatch(setGameSettings(response.data));
            } else {
                console.error("Invalid response from server.");
            }
        });
    } catch (error) {
        console.error("Error on fetchConfig:", error);
        return null;
    }
};

// 🔹 Connect Socket Function
export const connectSocket = (unauthorized, connectionLost, onConnection) => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return;

    if (!socket || socket.disconnected) {
        socket = io(SOCKET_SERVER_URL, {
            query: { access_token: accessToken },
            transports: ["websocket"],
            reconnection: true,
            reconnectionAttempts: 20,
            reconnectionDelay: 4000,
            timeout: 5000, // Wait max 5s for the server to respond
            pingInterval: 2000, // default is 25000ms
            pingTimeout: 1000,
        });

        socket.on("connected", async (data) => {
            console.log("Connected:", data);
            await fetchConfig();
            onConnection?.()
        });

        socket.on("disconnect", (reason) => {
            console.log("Socket disconnected", reason);
            if (!navigator.onLine) {
                console.warn("Internet connection lost!");
                connectionLost?.()
            } else {
                console.warn("Socket disconnected due to:", reason);
                unauthorized?.();
            }
        });

        socket.on("reconnect_failed", () => {
            console.warn("All reconnection attempts failed.");
            unauthorized?.(); // Call only after all retries fail
        });
    }

    return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};
